import { Checkbox, ConfigProvider, DatePicker, Input } from "antd"
import Modal from "antd/es/modal/Modal"
import '../styles.scss'
import { IRelative } from "../../../api/selectOptions/selectOptionsApi"
import { useEffect, useState } from "react"
import { Dayjs } from "dayjs"
import { flushSync } from "react-dom"
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
dayjs.locale('vi');
const { RangePicker } = DatePicker;

export interface ISLModalFilter {
  id: number | string;
  title: string;
}

interface ModalProp {
  isOpen: boolean
  rangeValue: string[] | null
  handleDateChange: (date: [Dayjs | null, Dayjs | null] | null) => void,
  closeModal: (isClose: boolean) => void
}
const ModalFilterDatePicker: React.FC<ModalProp> = ({
  isOpen, rangeValue, closeModal, handleDateChange
}) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(true);

  const [selectedValueTmp, setSelectedValueTmp] = useState<[Dayjs | null, Dayjs | null] | null>(null);

  const handleReset = () => {
    setSelectedValueTmp(null); // chỉ clear trong modal, chưa gọi API
  };

  const handleConfirm = () => {
    handleDateChange(selectedValueTmp);
    flushSync(() => {
      setIsDatePickerOpen(false);
    });
    closeModal(false); // lúc này state đã update xong
  }

  useEffect(() => {
    if (isOpen) {
      setIsDatePickerOpen(true);
      if (rangeValue && rangeValue[0] && rangeValue[1]) {
        const dateStart = dayjs(rangeValue[0], 'YYYY/MM/DD', true);
        const dateEnd = dayjs(rangeValue[1], 'YYYY/MM/DD', true);
        setSelectedValueTmp([dateStart, dateEnd])
      }
      else {
        setSelectedValueTmp(null)
      } // mỗi lần mở modal thì sync lại state tạm
    }
  }, [isOpen, rangeValue]);
  return (
    <Modal
      open={isOpen}
      title={false}
      footer={false}
      closeIcon={false}
      onCancel={() => {
        flushSync(() => {
          setIsDatePickerOpen(false);
        });
        closeModal(false); // lúc này state đã update xong
      }}
      className="w-modal-242"
    >

      <ConfigProvider locale={viVN}>
        <RangePicker
          className="custom-range-picker-input"
          open={isDatePickerOpen}
          placeholder={["Bắt đầu", "Kết thúc"]}
          format="DD/MM/YYYY"
          allowClear
          value={selectedValueTmp}

          onChange={(date) => setSelectedValueTmp(date)}
          renderExtraFooter={() => (
            <div className='w-full d-flex justify-between py-2'>
              <button className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'
                onClick={handleReset}
              >Làm mới</button>
              <button className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'
                onClick={handleConfirm}
              >Lưu</button>

            </div>

          )}
        />
      </ConfigProvider>
    </Modal>

  )
}
export default ModalFilterDatePicker
